module.exports = __webpack_public_path__ + "media/Loops 110 Strings 2.c5848462.wav";